'use client';

import { CommonVideoBlockProps } from '../../../types/schemas/objects/CommonVideoBlockProps';
import { getFallbackImgUrl } from '../../../utils/video/getFallbackImgUrl';
import VideoJsPlayer from '../videoJsPlayer/VideoJsPlayer';

type Props = CommonVideoBlockProps & {
	hlsSrc?: string;
	className?: string;
};

const CloudinaryHLSVideoEmbed = ({
	className,
	autoplay,
	playsinline,
	muted,
	loop,
	controls = true,
	hlsSrc,
	fallbackImg,
	pause,
}: Props) => {
	if (!hlsSrc) return null;

	const fallbackImageUrl = getFallbackImgUrl(fallbackImg?.url);

	return (
		<VideoJsPlayer
			className={className}
			pause={pause}
			options={{
				poster: fallbackImg && !autoplay && controls ? fallbackImageUrl : undefined,
				fluid: true,
				html5: {
					vhs: {
						overrideNative: true,
					},
				},
				sources: [
					{
						src: hlsSrc,
						type: 'application/x-mpegURL',
					},
				],
				bigPlayButton: !autoplay,
				controlBar: autoplay ? false : undefined,
				autoplay,
				playsinline,
				controls,
				loop,
				muted,
			}}
		/>
	);
};

CloudinaryHLSVideoEmbed.displayName = 'CloudinaryHLSVideoEmbed';
export default CloudinaryHLSVideoEmbed;
